import {
  PROVIDE_KEY_SHOW_ERROR_MODAL,
  ShowErrorModal,
} from "./../../types/index";
import { Ref, ref, inject } from "vue";
import { VERIFICATION_TIMER } from "@/types";
import { useUserStore } from "@/stores/userStore";
import useUnformattingPhoneNumber from "@/use/useUnformattingPhoneNumber";

export default function validateVerificationCode(
  phoneNumber: Ref<string>,
  didSendVerificationCode: Ref<boolean>
): {
  verificationCode: Ref<string>;
  isVerificationSuccess: Ref<boolean>;
  isVerificationTimeOut: Ref<boolean>;
  remainingTimeStr: Ref<string>;
  verificationCodeErrorMessage: Ref<string>;
  verificationCodeSuccessMessage: Ref<string>;
  onChangeVerificationCode: () => void;
  verifyCode: () => void;
  startTimer: () => void;
  stopTimer: () => void;
} {
  const showErrorModal = inject(PROVIDE_KEY_SHOW_ERROR_MODAL) as ShowErrorModal;

  const userStore = useUserStore();

  const verificationCode = ref("");
  const isVerificationSuccess = ref(false);
  let remainingTimeSec = VERIFICATION_TIMER;
  const isVerificationTimeOut = ref(false);
  let intervalId = 0;
  const remainingTimeStr = ref("");
  const verificationCodeErrorMessage = ref("");
  const verificationCodeSuccessMessage = ref("");

  const startTimer = () => {
    isVerificationTimeOut.value = false;
    verificationCodeErrorMessage.value = "";
    remainingTimeSec = VERIFICATION_TIMER;
    window.clearInterval(intervalId);
    countDown();
    intervalId = window.setInterval(countDown, 1000);
  };
  const countDown = () => {
    remainingTimeSec -= 1;
    remainingTimeStr.value = formattedTime(remainingTimeSec);
    if (remainingTimeSec === 0) {
      didSendVerificationCode.value = false;
      isVerificationTimeOut.value = true;
      verificationCode.value = "";
      verificationCodeErrorMessage.value = "휴대폰 인증을 다시 요청하세요.";
      stopTimer();
    }
  };
  const formattedTime = (time: number) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    if (minutes === 0 && seconds === 0) {
      return "시간만료";
    } else {
      return minutes === 0 ? `${seconds}초` : `${minutes}분 ${seconds}초`;
    }
  };
  const stopTimer = () => {
    window.clearInterval(intervalId);
  };

  const onChangeVerificationCode = () => {
    verificationCodeErrorMessage.value = "";
  };

  const verifyCode = async () => {
    const checkVerificationCodeResult =
      await userStore.checkPhoneVerificationCode(
        useUnformattingPhoneNumber(phoneNumber.value),
        verificationCode.value
      );
    if (checkVerificationCodeResult.isSuccess) {
      isVerificationSuccess.value = true;
      verificationCodeSuccessMessage.value = "인증이 완료되었습니다.";
      verificationCodeErrorMessage.value = "";
      remainingTimeStr.value = "";
      stopTimer();
      return;
    }
    if (checkVerificationCodeResult.resultCode === 401000301) {
      verificationCode.value = "";
      verificationCodeSuccessMessage.value = "";
      verificationCodeErrorMessage.value = "인증번호가 일치하지 않습니다.";
      return;
    }
    showErrorModal(
      "인증번호 확인 오류",
      checkVerificationCodeResult.errorMessage,
      checkVerificationCodeResult.resultCode,
      checkVerificationCodeResult.errorTime
    );
  };

  return {
    verificationCode,
    isVerificationSuccess,
    isVerificationTimeOut,
    remainingTimeStr,
    verificationCodeErrorMessage,
    verificationCodeSuccessMessage,
    onChangeVerificationCode,
    verifyCode,
    startTimer,
    stopTimer,
  };
}
